module.exports = "../../../../platform/assets/pageMainIcon/simple_danjuweihulei3.svg";